/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-08-08 19:45:47
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-08-08 19:47:34
 */
const sentryConfig = {
  dev: {
    url: 'http://10.10.75.137:9001/',
    project: 'msvc-web-dev',
    urlPrefix: 'http://10.10.45.52:18080/js',
    dsn: 'http://ad01fa796b79473f8a9b77a0f65636ac@10.10.45.52:9001/2'
  },
  test: {
    url: 'http://10.10.75.137:9001/',
    project: 'msvc-web-test',
    urlPrefix: 'http://10.10.75.137:18080/js',
    dsn: 'http://c671b8a98dd0464993050fc93d127479@10.10.75.137:9001/4'
  },
  pre: {
    url: 'http://172.31.20.248:9001/',
    project: 'msvc-web-pre',
    urlPrefix: 'https://presys.5ycap.com/js',
    dsn: 'https://a8188b506e1a4113bc61eb42b7748a5d@presys.5ycap.com/3'
  },
  prod: {
    url: 'http://172.31.21.90:9001/',
    project: 'msvc-web-pro',
    urlPrefix: 'https://sys.5ycap.com/js',
    dsn: 'https://e67faba2de944788bcc063754ef76b2d@sys.5ycap.com/5'
  },
}

module.exports = {sentryConfig}
